import { useState, useCallback } from 'react';

import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';

const displayText = {
  cancel: 'Cancel',
  label: 'Folder name',
  rename: 'Rename folder',
  next: 'Rename folder',
};

type RenameFolderModalProps = {
  folderName: string;
  onClose: () => void;
  onConfirm: (folderName: string) => void;
  isLoading?: boolean;
  maxNameLength?: number;
};

export const RenameFolderModal = ({
  folderName,
  onClose,
  onConfirm,
  isLoading,
  maxNameLength,
}: RenameFolderModalProps) => {
  const [newFolderName, setNewFolderName] = useState(folderName);
  const handleConfirm = useCallback(() => {
    onConfirm(newFolderName);
  }, [onConfirm, newFolderName]);

  return (
    <Modal
      data-test="rename-folder-modal-wrapper"
      id="rename-folder-modal"
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader data-test="rename-folder-modal-header">{displayText.rename}</ModalHeader>
      <ModalBody data-test="rename-folder-modal-body" id="rename-folder-modal-body">
        <FormField
          key="rename-folder-name"
          hasError={false}
          inputId="rename-folder-name"
          labelText={displayText.label}
          restrictionText={maxNameLength ? `${newFolderName.length}/${maxNameLength}` : undefined}
        >
          <InputText
            key="field-new-folder-name"
            id="new-folder-name"
            onChange={(nameOfFolder: string) => {
              setNewFolderName(nameOfFolder);
            }}
            type="text"
            value={newFolderName}
            maxLength={maxNameLength}
          />
        </FormField>
      </ModalBody>
      <ModalFooter
        cancelLabel={displayText.cancel}
        data-test="rename-folder-modal-actions"
        id="rename-folder-modal-actions"
      >
        <PrimaryButton
          isLoading={!!isLoading}
          data-test="next-button"
          onClick={handleConfirm}
          isDisabled={newFolderName.length === 0 || !!isLoading}
          size={BUTTON_SIZES.LARGE}
        >
          {displayText.next}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
